<template>
  <div>
    <b-card class="text-center">
      <b-row>
        <!-- 레이아웃조정용 -->
        <b-col md="4">
          <label for="ph_count" v-b-tooltip.hover>Percentage of resources</label><br>
          <vue-apex-charts class="mt-5" ref="_list" :width="thumbnail_size" type="donut" :options="options_resource" :series="data_resource"></vue-apex-charts>
        </b-col>
        <b-col md="4" class="animated fadeIn fadeOut mt-2">
          <label for="ph_count" v-b-tooltip.hover>Site Configuration Summary</label><br>
          <vue-apex-charts class="mt-5" ref="_list" :width="thumbnail_size" type="donut" :options="options_site" :series="data_site"></vue-apex-charts>
        </b-col>
        <!-- 간단한 요약 및 진행 정도 -->
        <b-col lg="4" xl="4">
          <b-card class="text-center" style="font-size:1.3em">
            <b-row>
              <b-col md="12">
                <b-button size="sm" block variant="info" @click="$emit('stop')"> Auto Refresh ({{refresh_timer}}) </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <table class="table">
                  <tr>
                    <td>

                      <label title="Displays the check start time" v-b-tooltip.hover>Started_at</label>
                      <small>
                        <span>
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </small>
                    </td>
                    <td>
                      {{result.started_at | utcdatetime }} ~
                    </td>
                  </tr>
                  <tr>
                    <td>

                      <label title="Displays the time during the inspection" v-b-tooltip.hover>Progress Time</label>
                      <small>
                        <span>
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </small>
                    </td>
                    <td>
                      <b-badge variant="primary" v-if="result && result.started_at && moment().diff(result.started_at, 'minutes') > 0">
                        {{moment().diff(result.started_at, 'minutes')}} minutes ~
                      </b-badge>
                      <b-badge variant="primary" v-else>
                        Preparing..
                      </b-badge>
                    </td>
                  </tr>
                  <tr>
                    <td>

                      <label title="Displays the inspection status" v-b-tooltip.hover>Status</label>
                      <small>
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </small>
                    </td>
                    <td>
                      <b-badge :variant="codes.TEXT_COLORS[result.status%5]"> {{codes.WMDS_INSPECT_STATUS[result.status] ? codes.WMDS_INSPECT_STATUS[result.status].toUpperCase() : ''}} </b-badge>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">

                      <label class="font-weight-bold" title="If there is a problem with the inspection, the corresponding inspection key is required for verification" v-b-tooltip.hover>TICKET</label>
                      <small>
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </small>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b-img @click="copy(result.guid, result.working_page)" style="display: inline-block; cursor: pointer;" v-bind="{ width: 15, height: 15 }"  src="ico/copy.ico" alt=""></b-img>
                      {{result.guid}}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">

                      <label class="font-weight-bold" title="Displays the page currently under inspection" v-b-tooltip.hover>Checking Page ( {{ result['page_qty'] | number }} pages reached )</label>
                      <small>
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </small>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <a v-if="result.working_page" target="_blank" :href="result.working_page" class="card-link">
                        <small><i class="fa fa-share"></i>  {{result.working_page | truncate(100) }}</small>
                      </a>
                      <span v-else></span>
                    </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
